import { render } from "./Entertainment.vue?vue&type=template&id=196733e3&scoped=true"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"

import "./Entertainment.vue?vue&type=style&index=0&id=196733e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-196733e3"

export default script